import {createErrorAction} from './utils';

const TYPES = {
    GET_ACTIVE_USERS_OVERVIEW: 'GET_ACTIVE_USERS_OVERVIEW',
    GET_ACTIVE_USERS_OVERVIEW_COMPLETE: 'GET_ACTIVE_USERS_OVERVIEW_COMPLETE',
    GET_ACTIVE_USERS_OVERVIEW_FAILED: 'GET_ACTIVE_USERS_OVERVIEW_FAILED'
};

export default {
    TYPES,

    getActiveUsersOverview: payload => ({
        type: TYPES.GET_ACTIVE_USERS_OVERVIEW,
        payload
    }),

    getActiveUsersOverviewSuccess: payload => ({
        type: TYPES.GET_ACTIVE_USERS_OVERVIEW_COMPLETE,
        payload
    }),

    getActiveUsersOverviewFailed: createErrorAction(TYPES.GET_ACTIVE_USERS_OVERVIEW_FAILED)
};
